import {
  toggleHelpStage,
  toggleListening,
  updateCurrentStage,
  togglePopupState
} from '@/composition/voiceState'
import tracking from '@/utils/gtm-util'

const commands = {}
let instructionsElement = null
let ingredientsElement = null
let steps = []
let currentStepIndex = -1
const offset = window.innerWidth < 768 ? 75 : 60

const cacheElements = () => {
  if (!instructionsElement) {
    instructionsElement = document.getElementById('preparation')
  }
  if (!ingredientsElement) {
    ingredientsElement = document.getElementById('ingredients')
  }
  steps = Array.from(document.querySelectorAll('.c-recipe-preparation__step'))
}

const observer = new MutationObserver(() => {
  cacheElements()
})

observer.observe(document.body, { childList: true, subtree: true })

const scrollToStep = () => {
  if (steps.length > 0 && steps[currentStepIndex]) {
    const stepElement = steps[currentStepIndex]
    const elementPosition = stepElement.getBoundingClientRect().top + window.scrollY
    const offsetPosition = elementPosition - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }

  if (steps.length === currentStepIndex + 1) {
    updateCurrentStage('listening almost-done')
    togglePopupState(true)
  } else {
    updateCurrentStage('listening')
    togglePopupState(false)
  }
}

const addCommand = (aliases, action) => {
  aliases.forEach((alias) => {
    commands[alias] = action
  })
}

export default function useCommands(model) {
  if (!model) {
    return commands
  }

  addCommand(model.help, () => {
    updateCurrentStage('listening help')
    toggleHelpStage(true)
    togglePopupState(true)
    tracking.handsfreeVoiceCommand('help')
    if (currentStepIndex > 0) {
      currentStepIndex -= 1
    }
  })

  addCommand(model.scrollUp, () => {
    window.scrollBy({
      top: -300,
      behavior: 'smooth'
    })
    tracking.handsfreeVoiceCommand('scroll up')
  })

  addCommand(model.scrollDown, () => {
    window.scrollBy({
      top: 300,
      behavior: 'smooth'
    })
    tracking.handsfreeVoiceCommand('scroll down')
  })

  addCommand(model.exit, () => {
    updateCurrentStage('listening')
    toggleHelpStage(false)
  })

  addCommand(model.goToInstructions, () => {
    if (!instructionsElement) {
      cacheElements()
    }
    if (instructionsElement) {
      window.scrollTo({
        top: instructionsElement.offsetTop - offset,
        behavior: 'smooth'
      })
      tracking.handsfreeVoiceCommand('go to instructions')
    }
    if (currentStepIndex > 0) {
      currentStepIndex -= 1
      updateCurrentStage('listening')
      togglePopupState(false)
    }
  })

  addCommand(model.goToIngredients, () => {
    if (!ingredientsElement) {
      cacheElements()
    }
    if (instructionsElement) {
      window.scrollTo({
        top: ingredientsElement.offsetTop - offset,
        behavior: 'smooth'
      })
      tracking.handsfreeVoiceCommand('go to ingredients')
    }
    if (currentStepIndex > 0) {
      currentStepIndex -= 1
      updateCurrentStage('listening')
      togglePopupState(false)
    }
  })

  addCommand(model.nextStep, () => {
    if (steps.length === 0) {
      cacheElements()
    }

    if (currentStepIndex < steps.length - 1) {
      currentStepIndex += 1
      scrollToStep()
      tracking.handsfreeVoiceCommand('next step')
    }
  })

  addCommand(model.previousStep, () => {
    if (steps.length === 0) {
      cacheElements()
    }

    if (currentStepIndex > 0) {
      currentStepIndex -= 1
      scrollToStep()
      tracking.handsfreeVoiceCommand('previous step')
    }
  })

  addCommand(model.letsCook, () => {
    toggleListening(true)
    updateCurrentStage('listening')
    togglePopupState(false)
    tracking.handsfreeVoiceCommand('let\'s cook')
  })

  addCommand(model.imDone, () => {
    tracking.handsfreeVoiceCommand('i\'m done')
  })

  return commands
}
